import React from 'react';
import { AddQuotaButton, Select } from 'components';
import { ComponentProps } from '@app/participant-fields';
import { Criterion, ParticipantFieldType } from 'queries';
import { useMultiSelectToCriterion } from './useMultiSelectToCriterion';
import {
  useAddQuotaButtonHandler,
  useOnCriterionChange,
} from './useCriterionQuotasHooks';
import { CriterionQuotaList } from './CriterionQuotaList';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  criterionContainer: {
    backgroundColor: theme.colors.grayBackground,
    borderRadius: theme.borderRadius.std,
    padding: theme.marginBase * 2,
  },
  quotaContainer: {
    borderRadius: theme.borderRadius.std,
    paddingTop: theme.marginBase,
  },
  noPadding: {
    padding: 0,
  },
}));

export const CriterionSelect = ({
  field,
  onChange,
  value: criterion,
  allowedFields,
  criteria,
  numberOfParticipantRequired,
  ...props
}: ComponentProps<Criterion>) => {
  const classes = useStyles();
  const options = props.options || field.choices || [];

  const isSingleChoice = field.type === ParticipantFieldType.SINGLE_CHOICE;
  const showQuotas = !!criterion.quotas && !!criterion.allowList;

  const handleQuotasButton = useAddQuotaButtonHandler({
    showQuotas,
    criterion,
    onChange,
    numberOfParticipantRequired,
    options,
  });

  const onCriterionChange = useOnCriterionChange({
    showQuotas,
    criterion,
    onChange,
    numberOfParticipantRequired,
  });

  const [value, _onChange] = useMultiSelectToCriterion(
    criterion,
    onCriterionChange,
  );

  return (
    <>
      <div
        className={classnames(classes.criterionContainer, {
          [classes.noPadding]: !isSingleChoice,
        })}
      >
        <Select
          isMulti
          color="green"
          {...props}
          options={options}
          value={value}
          onChange={_onChange}
          rightAction={
            isSingleChoice && (
              <AddQuotaButton value={showQuotas} onClick={handleQuotasButton} />
            )
          }
        />
      </div>
      {showQuotas && (
        <div className={classes.quotaContainer}>
          <CriterionQuotaList
            criterion={criterion}
            options={options}
            numberOfParticipantRequired={numberOfParticipantRequired}
            onChange={onChange}
          />
        </div>
      )}
    </>
  );
};
